import { PATH_URL } from './path-url';

const BASE = `${PATH_URL}/logos/brands`;

export interface StoreLogo {
  value: string;
  label: string;
  imageUrl: string;
}

/** Logos de comercios para la grilla (opciones del image-multi-select). */
export const STORES: StoreLogo[] = [
  { value: 'changomas', label: 'ChangoMás', imageUrl: `${BASE}/changomas.png` },
  { value: 'diarco', label: 'Diarco', imageUrl: `${BASE}/diarco.png` },
  { value: 'makro', label: 'Makro', imageUrl: `${BASE}/makro.png` },
  { value: 'libertad', label: 'Libertad', imageUrl: `${BASE}/libertad.png` },
  { value: 'toledo', label: 'Toledo', imageUrl: `${BASE}/toledo.png` }
];
